import LogicaAPI from "./logicaapi";

export default class Advertising extends LogicaAPI {
  getAdvertising(id) {
    return this.get(
      `/api/v1/advertisings/${id}?expand_object_depth=2&datasource=decorator`
    );
  }
}
